export default __webpack_public_path__ + "static/calendar-ee53af798d88fd040effe1c77bfecd98.png";